class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)

    this.shouldBeVisible
      ? document.body.classList.add('util-FixedBar')
      : document.body.classList.remove('util-FixedBar')

    const footerEl = document.querySelector(
      '[data-product-fixed-bar-external-el="footer"]',
    )

    this.shouldBeVisible
      ? footerEl.style.setProperty('--FixedBarHeight', `${this.offsetHeight}px`)
      : footerEl.style.setProperty('--FixedBarHeight', 0)
  }

  get shouldBeVisible () {
    const buttonEl = document.querySelector(
      '[data-product-fixed-bar-external-el="button"]',
    )

    if (!buttonEl) return

    const threshold =
      window.BAO.Utils.getOffsetTop(buttonEl) + buttonEl.offsetHeight

    return this.lastKnownY > threshold
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
